import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/brand/Logo";
import { useAuth } from "@/context/AuthContext";
import { api, formatErr } from "@/lib/api";

const Pwd = ({ label, value, onChange, testId, auto }) => (
  <div><Label className="text-xs">{label}</Label><Input type="password" autoComplete={auto} required value={value} onChange={(e) => onChange(e.target.value)} className="mt-1.5 h-12 rounded-xl bg-white" data-testid={testId} /></div>
);

export default function ChangePassword() {
  const { user, setUser, logout } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const forced = !!user?.must_change_password;
  const submit = async (e) => {
    e.preventDefault();
    if (p1.length < 8) return setErr("La nuova password deve avere almeno 8 caratteri");
    if (p1 !== p2) return setErr("Le due password non coincidono");
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: p1 });
      setUser({ ...user, must_change_password: false });
      toast.success("Password aggiornata");
      nav("/portale", { replace: true });
    } catch (e2) {
      setErr(formatErr(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#F5F5F7] px-6 py-10">
      <form onSubmit={submit} className="panel w-full max-w-sm space-y-4 p-8" data-testid="change-password-form">
        <Logo size={28} />
        {!forced && <Link to="/portale" className="inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-black" data-testid="change-password-back"><ArrowLeft className="h-4 w-4" />La tua area</Link>}
        <div>
          <h1 className="text-2xl font-semibold">{forced ? "Scegli la tua password" : "Cambia password"}</h1>
          <p className="mt-2 text-sm text-zinc-500">{forced ? "È il tuo primo accesso: sostituisci la password che hai ricevuto con una scelta da te." : "Inserisci la password attuale e quella nuova."}</p>
        </div>
        <Pwd label={forced ? "Password ricevuta" : "Password attuale"} value={cur} onChange={setCur} testId="change-password-current" auto="current-password" />
        <Pwd label="Nuova password (almeno 8 caratteri)" value={p1} onChange={setP1} testId="change-password-new" auto="new-password" />
        <Pwd label="Ripeti la nuova password" value={p2} onChange={setP2} testId="change-password-confirm" auto="new-password" />
        {err && <p className="text-sm text-red-600" data-testid="change-password-error">{err}</p>}
        <Button type="submit" disabled={busy} className="h-12 w-full" data-testid="change-password-submit">{busy ? "Salvataggio…" : "Salva password"}</Button>
        {forced && <button type="button" onClick={logout} className="w-full text-center text-xs text-zinc-500 hover:text-black" data-testid="change-password-logout">Esci</button>}
      </form>
    </div>
  );
}
